export const PostLogin = (datas) => {
    return ({
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(datas),
    });
}

export const PostRefresh = (datas) => {
    return ({
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ refresh: datas }),
    });
}

export const GetHeaders = (token) => {
    return ({
        method: 'GET',
        headers: { 'Authorization': token, 'Content-Type': 'application/json' }
    });
}

export const PostHeaders = (token, datas) => {
    return ({
        method: 'POST',
        headers: { 'Authorization': token, 'Content-Type': 'application/json' },
        body: JSON.stringify(datas)
    })    
}    
